import { Col, Tabs } from "antd"
import React, { ReactElement, useEffect, useRef, useState } from 'react'
import { TabPane } from "../../../../compnents/widgets/TabBar"
import styles from '../../functionSettingTabs.module.css'
import { MedicalRecordSetting } from "./medicalRecordSettings/MedicalRecordSetting"
import { PatientSetting } from "./patientSettings/PatientSetting"
import { useSelector } from "react-redux"
import { selectMenus } from "../../../../layouts/layoutSlice"
import { selectEdition } from "../../../../app/applicationSlice"
import { RegisterSetting } from "./registerSettings/registerSettings"
import { AppointmentSetting } from "./AppointmentSetting/AppointmentSetting"

export const FieldSetting = (props: {
  selectedTab: any
}): ReactElement => {
  const menus = useSelector(selectMenus)

  const hisVersion = useSelector(selectEdition)

  const ysmzFlag = menus?.filter((v) => {
    return v?.name == '医生门诊'
  })

  const hzglFlag = menus?.filter((v) => {
    return v?.name == '患者管理'
  })

  const ghFlag = menus?.filter((v) => {
    return v?.name == '挂号'
  })

  const yzFlag = menus?.filter((v) => {
    return v?.name == '预约'
  })

  console.log(ysmzFlag, menus, "ysmzFlag")
  const [selectedTab, setSelectedTab] = useState('A1')

  useEffect(() => {
    if (props?.selectedTab === '11') {
      if (ysmzFlag?.length) {
        setSelectedTab('A1')
      } else {
        setSelectedTab('A2')
      }
    }
  }, [props?.selectedTab])

  return (
    <Col className={styles.fieldSettinContainer}>
      <Tabs
        tabPosition={'top'}
        defaultActiveKey="A1"
        onChange={(key: string) => {
          setSelectedTab(key)
        }}
      >
        {(hisVersion == 1 ? hzglFlag : ysmzFlag)?.length ? (
          <TabPane key='A1' tab='病历设置'>
            <MedicalRecordSetting selectedTab={selectedTab}></MedicalRecordSetting>
          </TabPane>
        ) : (
          <></>
        )}
        <TabPane key='A2' tab='患者设置'>
          <PatientSetting selectedTab={selectedTab}></PatientSetting>
        </TabPane>
        <TabPane key='A3' tab='挂号设置'>
          <RegisterSetting selectedTab={selectedTab}></RegisterSetting>
        </TabPane>
        <TabPane key='A4' tab='预约设置'>
          <AppointmentSetting selectedTab={selectedTab}></AppointmentSetting>
        </TabPane>
      </Tabs>
    </Col>
  )
}
